import { Theme, createTheme, responsiveFontSizes } from "@mui/material/styles";
import ColorData from "./ColorData";

function setSpacing(value) {
  const width = window.innerWidth;
  if (width < 600) return 5 * value;
  else if (width < 900) return 6 * value;
  else if (width < 1200) return 7 * value;
  else return 8 * value;
}

export let appTheme = createTheme({
  typography: {
    fontFamily: ["DM Sans", "sans-serif"].join(","),
    allVariants: {
      color: ColorData.text.primary,
    },
    h1: {
      fontFamily: "Playfair Display",
      fontSize: "5rem", // 80px
      //   lineHeight: "5.125rem", // 82px
      fontWeight: 900,
      color: ColorData.heading.main,
    },
    h2: {
      fontFamily: "Playfair Display",
      fontSize: "2.75rem", // 44px
      //   lineHeight: "3.25rem", // 52px
      fontWeight: 700,
      color: ColorData.heading.main,
    },
    h3: {
      fontFamily: "Playfair Display",
      fontSize: "2.5rem", // 40px
      //   lineHeight: "3rem", // 48px
      fontWeight: 700,
      color: ColorData.heading.main,
    },
    h4: {
      fontFamily: "Playfair Display",
      fontSize: "2.25rem", // 36px
      //   lineHeight: "2.75rem", // 44px
      fontWeight: 700,
      color: ColorData.heading.main,
    },
    h5: {
      fontFamily: "Playfair Display",
      fontSize: "1.875rem", // 30px
      //   lineHeight: "2.25rem", // 36px
      fontWeight: 700,
      color: ColorData.heading.contrast,
    },
    h6: {
      fontFamily: "Playfair Display",
      fontSize: "1.5rem", // 24px
      //   lineHeight: "2rem", // 32px
      fontWeight: 700,
      color: ColorData.heading.contrast,
    },
    body1: {
      fontSize: "1rem",
      fontFamily: "DM Sans",
      fontWeight: 400,
      color: ColorData.text.primary,
    },
    body2: {
      fontSize: "0.9rem",
      fontFamily: "DM Sans",
      fontWeight: 400,
      color: ColorData.text.primary,
    },
    navHeader: {
      color: ColorData.text.primary,
      fontSize: "1rem",
      lineHeight: "22px",
      fontWeight: 500,
    },
  },
  palette: {
    ...ColorData,
    text: {
      primary: ColorData.text.primary,
      secondary: "#2c2a2aff",
    },
  },
  spacing: setSpacing,
});

appTheme = responsiveFontSizes(appTheme);
